<template>
  <header :class="[props.inset ? 'absolute inset-x-0 top-0 z-50' : 'bg-white']">
    <nav
      class="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
      aria-label="Global"
    >
      <div class="flex lg:flex-1">
        <Link :href="route('marketing.home')" class="-m-1.5 p-1.5" prefetch>
          <span class="sr-only">BidBoost</span>
          <ApplicationLogo
            :color="props.isOnDarkBackground ? 'white' : 'indigo'"
            size="h-8 w-auto sm:h-10"
          />
        </Link>
      </div>
      <div class="flex lg:hidden">
        <button
          type="button"
          class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5"
          :class="[
            props.isOnDarkBackground ? 'text-gray-300' : 'text-gray-700',
          ]"
          @click="mobileMenuOpen = true"
        >
          <span class="sr-only">Open main menu</span>
          <Bars3Icon class="h-6 w-6" aria-hidden="true" />
        </button>
      </div>
      <PopoverGroup class="hidden lg:flex lg:gap-x-8 2xl:gap-x-12">
        <MenuItem
          v-for="item in navigation"
          :key="item.name"
          :name="item.name"
          :items="item.items"
          :href="item.href"
          :textColor="isOnDarkBackground ? 'text-white' : 'text-gray-900'"
          :arrowColor="isOnDarkBackground ? 'text-gray-300' : 'text-gray-400'"
        />
      </PopoverGroup>
      <div class="hidden lg:flex lg:flex-1 lg:justify-end">
        <Link
          v-if="useUser"
          :href="route('dashboard')"
          class="group text-sm font-semibold leading-6"
          :class="isOnDarkBackground ? 'text-white' : 'text-gray-900'"
          prefetch
          >Dashboard <TextArrow
        /></Link>

        <Link
          v-else
          :href="route('login')"
          class="group text-sm font-semibold leading-6"
          :class="isOnDarkBackground ? 'text-white' : 'text-gray-900'"
          prefetch
          >Log in <TextArrow
        /></Link>
      </div>
    </nav>
    <Dialog
      as="div"
      class="lg:hidden"
      @close="mobileMenuOpen = false"
      :open="mobileMenuOpen"
    >
      <div class="fixed inset-0 z-50" />
      <DialogPanel
        class="fixed inset-y-0 right-0 z-50 flex w-full flex-col justify-between overflow-y-auto bg-white sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
      >
        <div class="p-6">
          <div class="flex items-center justify-between">
            <Link :href="route('marketing.home')" class="-m-1.5 p-1.5" prefetch>
              <span class="sr-only">BidBoost</span>
              <ApplicationLogo size="h-8 w-auto" color="indigo" />
            </Link>

            <button
              type="button"
              class="-m-2.5 rounded-md p-2.5 text-gray-700"
              @click="mobileMenuOpen = false"
            >
              <span class="sr-only">Close menu</span>
              <XMarkIcon class="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div class="mt-6 flow-root">
            <div class="-my-6 divide-y divide-gray-500/10">
              <!-- <div class="space-y-2 py-6">
                <a
                  v-for="item in products"
                  :key="item.name"
                  :href="item.href"
                  class="group -mx-3 flex items-center gap-x-6 rounded-lg p-3 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  <div
                    class="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white"
                  >
                    <component
                      :is="item.icon"
                      class="h-6 w-6 text-gray-600 group-hover:text-indigo-600"
                      aria-hidden="true"
                    />
                  </div>
                  {{ item.name }}
                </a>
              </div> -->
              <div class="space-y-2 py-6">
                <template v-for="item in navigation">
                  <Disclosure
                    v-if="item.items?.length"
                    as="div"
                    class="-mx-3"
                    v-slot="{ open }"
                  >
                    <DisclosureButton
                      class="flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                    >
                      {{ item.name }}
                      <ChevronDownIcon
                        :class="[open ? 'rotate-180' : '', 'size-5 flex-none']"
                        aria-hidden="true"
                      />
                    </DisclosureButton>
                    <DisclosurePanel class="mt-2 space-y-2">
                      <DisclosureButton
                        v-for="subItem in item.items"
                        :key="subItem.name"
                        :as="Link"
                        :href="subItem.href"
                        class="block rounded-lg py-2 pl-6 pr-3 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                        prefetch
                        >{{ subItem.name }}</DisclosureButton
                      >
                    </DisclosurePanel>
                  </Disclosure>

                  <Link
                    v-else
                    :href="item.href"
                    class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                    prefetch
                  >
                    {{ item.name }}
                  </Link>
                </template>
              </div>
              <div class="py-6">
                <Link
                  v-if="useUser"
                  :href="route('dashboard')"
                  class="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                  prefetch
                  >Dashboard</Link
                >
                <Link
                  v-else
                  :href="route('login')"
                  class="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                  prefetch
                  >Log in</Link
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="sticky bottom-0 grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50 text-center"
          v-if="usePage().props.value.environment !== 'staging'"
        >
          <Link
            v-if="!useUser"
            :href="route('register')"
            class="p-3 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-100"
            prefetch
            >Sign Up</Link
          >

          <Link
            :href="route('marketing.contact.index')"
            class="p-3 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-100"
            :class="useUser ? 'col-span-2' : ''"
            prefetch
            >Contact Us</Link
          >
        </div>
      </DialogPanel>
    </Dialog>
  </header>
</template>

<script setup>
import TextArrow from '@/Common/Text/Parts/TextArrow.vue'
import { useUser } from '@/Common/util/hooks/useUser'
import Link from '@/Common/util/inertia/Link.vue'
import ApplicationLogo from '@/Components/Logos/ApplicationLogo.vue'
import {
  Dialog,
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  PopoverGroup,
} from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import { Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline'
import { usePage } from '@inertiajs/inertia-vue3'
import { ref } from 'vue'
import { useNavigation } from '../useNavigation'
import MenuItem from './MenuItem.vue'

const props = defineProps({
  inset: Boolean,
  isOnDarkBackground: Boolean,
})

const { navigation } = useNavigation()

const mobileMenuOpen = ref(false)
</script>
